export enum SelectionStep {
	Intro,
	Layout,
	Style,
	Done,
	Legal,
}

export interface OptionSelection {
	name: string;
	thumb?: string;
}

export interface SelectionsState {
	step: SelectionStep;
	optionsValue: number;
	styleIndex: number;
	layoutIndex: number;
	qrCode?: string;
}

export const SET_SELECTION_STEP = "SET_SELECTION_STEP";

interface SetSelectionStepAction {
	type: typeof SET_SELECTION_STEP;
	step: SelectionStep;
}

export const SET_SELECTED_STYLE = "SET_SELECTED_STYLE";

interface SetSelectedStyleAction {
	type: typeof SET_SELECTED_STYLE;
	styleIndex: number;
}

export const SET_SELECTED_LAYOUT = "SET_SELECTED_LAYOUT";

interface SetSelectedLayoutAction {
	type: typeof SET_SELECTED_LAYOUT;
	layoutIndex: number;
}

export const SET_SELECTED_OPTIONS = "SET_SELECTED_OPTIONS";

interface SetSelectedOptionsAction {
	type: typeof SET_SELECTED_OPTIONS;
	optionsValue: number;
}

export const SET_QR_CODE = "SET_QR_CODE";

interface SetQrCodeAction {
	type: typeof SET_QR_CODE;
	qrCode?: string;
}

export const THUNK = "THUNK";

interface SetThunkAction {
	type: typeof THUNK;
}

export type SelectionsActionTypes =
	| SetSelectionStepAction
	| SetSelectedStyleAction
	| SetSelectedLayoutAction
	| SetSelectedOptionsAction
	| SetQrCodeAction
	| SetThunkAction;
